import React, { type PropsWithChildren, useMemo } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { type Edges, SafeAreaView } from 'react-native-safe-area-context';

import { type AddressType, theme } from '@sg/garnish';

export const BagContentContainer = (props: Props) => {
  const { children, restaurantSlug, orderChannel } = props;

  // ───────────────────────────────────────────────────────────────────────────

  // Web-only attributes, read by the e2e suite to get a bag's context.
  const dataSetProps = useMemo(
    () => ({
      dataSet: { 'bag-restaurant-slug': restaurantSlug, 'bag-order-channel': orderChannel },
    }),
    [restaurantSlug, orderChannel],
  );

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <SafeAreaView edges={SAFE_AREA_EDGES} style={styles.bagContentContainer} {...dataSetProps}>
      {children}
    </SafeAreaView>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SAFE_AREA_EDGES: Edges = Platform.select({
  android: ['bottom'],
  default: [],
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  bagContentContainer: {
    flex: 1,
    paddingHorizontal: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  restaurantSlug: string;
  orderChannel: AddressType;
}>;
